/** Last segment of a folder path — the folder's own name. */
export const folderName = (folderPath: string): string => folderPath.split('/').pop() as string
